import { render, staticRenderFns } from "./LocationPage.vue?vue&type=template&id=19384b02&scoped=true&"
import script from "./LocationPage.vue?vue&type=script&lang=js&"
export * from "./LocationPage.vue?vue&type=script&lang=js&"
import style0 from "./LocationPage.vue?vue&type=style&index=0&id=19384b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19384b02",
  null
  
)

export default component.exports